<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <!-- <h4 class="color-secundary">Base garantizados</h4> -->
      <p class="mb-5 text-justify">
        <!-- <b>Icono circular:</b> a través de esta opcíón, se puede descargar la base de garantizados al último corte contable.
        <br />-->
        <b>Filtro:</b> a través de esta opcíón, se puede descargar un resumen de
        utilizaciones, en un periodo de tiempo determinado.
      </p>

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        @click-buscar="buscar"
        @click-event="clickEvent"
        pagination
        filtro
        :dataLength="dataLength"
        :showExportToExcel="true"
        :showFilterDates="true"
        :perPage="perPage"
      >
        <table-column
          slot="label"
          :label="'Id de garantía'"
          v-bind:value="'sig_garantia_id'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'NIT del Intermediario'"
          v-bind:value="'nit'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Cédula'"
          v-bind:value="'cedula'"
          :filter="'numeric'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Pagaré'"
          v-bind:value="'pagare'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Referencia de crédito'"
          v-bind:value="'ref_credito'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Producto'"
          v-bind:value="'producto'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor de la utilización'"
          v-bind:value="'vlr_utilizacion'"
          :filter="'numberFormat'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor de servicio de fianza'"
          v-bind:value="'vsf'"
          :filter="'numberFormat'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha de utilización'"
          v-bind:value="'fecha_utilizacion'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Plazo'"
          v-bind:value="'plazo_utilizacion'"
          :customClass="'text-center'"
        ></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      perPage: 25,
      dataLength: 0,
      data: [],
      fecha_inicio: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD 00:00:00"),
      fecha_fin: this.$moment().format("YYYY-MM-DD 23:59:59"),
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      loading: "loading",
    }),
    saveToExcel() {},
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    buscar(event) {
      this.fecha_inicio = event.fecha_inicio;
      this.fecha_fin = event.fecha_fin;
      this.convenio = event.convenio;
      this.estadoGarantiaSelected = event.filterEstadoGarantiaSelected;
      this.loadData(this.perPage, 1);
    },
    async clickEvent(data, slug) {
      this.fecha_inicio = data.fecha_inicio;
      this.fecha_fin = data.fecha_fin;
      this.convenio = data.convenio;
      this.estadoGarantiaSelected = data.filterEstadoGarantiaSelected;
      switch (slug) {
        case "paginacion":
          this.perPage = data.nRows;
          this.loadData(data.nRows, data.page);
          break;
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 50000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            const { datos } = await this.loadData(0, 0, false, true);

            let response = [];
            datos.forEach((element) => {
              response.push({
                sig_garantia_id: element.sig_garantia_id,
                nit: element.nit,
                cedula: element.cedula,
                pagare: element.pagare,
                ref_credito: element.ref_credito,
                producto: element.producto,
                vlr_utilizacion: element.vlr_utilizacion,
                vsf: element.valor_servicio_fianza,
                fecha_utilizacion: element.fecha_utilizacion,
                plazo_utilizacion: element.plazo_utilizacion,
              });
            });

            let data = XLSX.utils.json_to_sheet(response, {
              header: [
                "sig_garantia_id",
                "nit",
                "cedula",
                "pagare",
                "ref_credito",
                "producto",
                "vlr_utilizacion",
                "vsf",
                "fecha_utilizacion",
                "plazo_utilizacion",
              ],
            });

            data["A1"].v = "Id de garantía";
            data["B1"].v = "NIT del intermediario";
            data["C1"].v = "Cédula";
            data["D1"].v = "Pagaré";
            data["E1"].v = "Referencia de crédito";
            data["F1"].v = "Producto";
            data["G1"].v = "Valor de la utilización";
            data["H1"].v = "Valor de servicio de fianza";
            data["I1"].v = "Fecha de utilización";
            data["J1"].v = "Plazo";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(
              workbook,
              data,
              "Resumen utilizaciones"
            );
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              "ResumenUtilizaciones.xlsx"
            );

            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
        default:
          break;
      }
    },
    async loadData(row, page, paginar = 1, exportar = false) {
      this.$store.commit("SET_LOADING", true);

      try {
        const { data } = await this.$store.state.api.get(
          "portal/informes/informe_utilizacion",
          {
            params: {
              paginar: paginar,
              fecha_inicio: this.$moment(this.fecha_inicio).format(
                "YYYY-MM-DD"
              ),
              fecha_fin: this.$moment(this.fecha_fin).format("YYYY-MM-DD"),
              convenio: this.convenio,
              row: row,
              page: page,
            },
          }
        );

        if (exportar === true) {
          return data;
        }

        this.data = [];
        this.dataLength = 0;
        data.datos.forEach(element => {
          this.data.push({
            sig_garantia_id: element.sig_garantia_id,
            nit: element.nit,
            cedula: element.cedula,
            pagare: element.pagare,
            ref_credito: element.ref_credito,
            producto: element.producto,
            vlr_utilizacion: element.vlr_utilizacion,
            vsf: element.valor_servicio_fianza,
            fecha_utilizacion: element.fecha_utilizacion,
            plazo_utilizacion: element.plazo_utilizacion,
          });
        });

        this.dataLength = data.total;
        this.$store.commit("SET_LOADING", false);
        return true;
      } catch (err) {
        this.$toasted.show("Ocurrió un error al intentar consultar los datos", {
          theme: "toasted-primary",
          position: "top-right",
          duration: 10000,
        });
        this.$store.commit("SET_LOADING", false);
        return false;
      }
    },
  },
  mounted() {
    this.loadData(this.perPage, 1);
  },
};
</script>